var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.04171 11.333H6.95837C6.61202 11.333 6.33337 11.0543 6.33337 10.7079V6.33227H4.04952C3.58598 6.33227 3.35421 5.7723 3.68233 5.44412L7.64327 1.48C7.83858 1.28466 8.15889 1.28466 8.35421 1.48L12.3177 5.44412C12.6459 5.7723 12.4141 6.33227 11.9506 6.33227H9.66671V10.7079C9.66671 11.0543 9.38806 11.333 9.04171 11.333ZM14.6667 11.1246V14.0417C14.6667 14.3881 14.3881 14.6668 14.0417 14.6668H1.95837C1.61202 14.6668 1.33337 14.3881 1.33337 14.0417V11.1246C1.33337 10.7782 1.61202 10.4996 1.95837 10.4996H5.50004V10.7079C5.50004 11.5127 6.15369 12.1665 6.95837 12.1665H9.04171C9.84639 12.1665 10.5 11.5127 10.5 10.7079V10.4996H14.0417C14.3881 10.4996 14.6667 10.7782 14.6667 11.1246ZM11.4375 13.4166C11.4375 13.1301 11.2032 12.8957 10.9167 12.8957C10.6302 12.8957 10.3959 13.1301 10.3959 13.4166C10.3959 13.7031 10.6302 13.9376 10.9167 13.9376C11.2032 13.9376 11.4375 13.7031 11.4375 13.4166ZM13.1042 13.4166C13.1042 13.1301 12.8698 12.8957 12.5834 12.8957C12.2969 12.8957 12.0625 13.1301 12.0625 13.4166C12.0625 13.7031 12.2969 13.9376 12.5834 13.9376C12.8698 13.9376 13.1042 13.7031 13.1042 13.4166Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadSolid);
export default __webpack_public_path__ + "static/media/upload-solid.0c10801513dbb2b5baea41d97260ad81.svg";
export { ForwardRef as ReactComponent };